export const RIBBON_WIDTH = 64;
export const MOBILE_RIBBON_WIDTH = 56;
